// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {RelatedcoursesModuleLayout} from 'app_components/modules/academic/relatedcourses'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IRelatedcoursesModuleProps {
  type: string
}
interface IRelatedcoursesModuleState {
  loading: boolean  
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class RelatedcoursesModule extends Component<IRelatedcoursesModuleProps, IRelatedcoursesModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IRelatedcoursesModuleProps) {
    super(props)
    this.state = {
      loading: true
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    setTimeout(() => {
      this.setState({
        loading: false
      })
    }, 1000)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <RelatedcoursesModuleLayout
        loading={this.state.loading}
        type={this.props.type}
      />
    )
  }
}

export default connect(mapStatesToProps)(RelatedcoursesModule)
